@if (!surveyHistoryData.length) {
  <div>No survey responses found.</div>
}

@for (entry of surveyHistoryData; track entry.srvyId) {
  <ppl-accordion
    [title]="(entry.srvyDesc || 'Survey') + (entry.srvyDate ? ' - ' + entry.srvyDate : '')"
    [additionalText]="'Submitted on: ' + entry.srvySubmitDate"
    [isOpen]="$index === 0">
    <ppl-survey-form mode="read" [historyEntry]="entry"></ppl-survey-form>
  </ppl-accordion>
}
